import React from 'react'
import { Card } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const AdminUsers = () => {
  const { t } = useTranslation()
  return (
    <Card className="card-bordered card-preview">
      <div className="card-inner">
        <h5 className="text-muted text-center py-5">{t('admin.tabs.users')} (Disabled)</h5>
      </div>
    </Card>
  )
}

export default AdminUsers
